import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import { useFiltersUsers } from "@/pages/SettingsPage/application/users/useUsers"

export const FilterUsersTab = () => {
  const { response, isLoading } = useFiltersUsers()
  const filters = response?.data?.all

  return (
    <Filter.Provider isLoading={isLoading}>
      <Filter.Template
        isLoading={isLoading}
        search={
          isLoading ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch id="FilterUsers" filters={filters} />
          )
        }
      />
    </Filter.Provider>
  )
}
